// A tela tinha DOIS seletores de página: um de caixa do Facebook e outro de
// página do Estúdio Social. Como o App Review negou `pages_show_list`, o
// primeiro vem vazio para todo cliente — e era ele que aparecia primeiro, com
// cara de obrigatório. Aqui as duas origens viram UMA lista só.
export const ORIGEM_CAIXA = 'inbox';
export const ORIGEM_SOCIAL = 'social';

export const opcoesDePagina = ({ facebookInboxes = [], socialPages = [] }) => [
  ...facebookInboxes.map(inbox => ({
    value: `${ORIGEM_CAIXA}:${inbox.channel_id}`,
    label: inbox.name,
    origem: ORIGEM_CAIXA,
  })),
  ...socialPages.map(pagina => ({
    value: `${ORIGEM_SOCIAL}:${pagina.id}`,
    label: pagina.name,
    origem: ORIGEM_SOCIAL,
  })),
];

// O valor guardado no formulário continua em duas colunas diferentes, porque é
// assim que o backend decide entre puxar leads pela Graph ou pela Zernio.
export const valorDaPagina = ({
  channel_facebook_page_id: caixa,
  social_account_id: social,
}) => {
  if (social) return `${ORIGEM_SOCIAL}:${social}`;
  if (caixa) return `${ORIGEM_CAIXA}:${caixa}`;
  return '';
};

export const camposDaPagina = valor => {
  const [origem, id] = String(valor || '').split(':');
  if (!id) return { channel_facebook_page_id: '', social_account_id: '' };
  return {
    channel_facebook_page_id: origem === ORIGEM_CAIXA ? id : '',
    social_account_id: origem === ORIGEM_SOCIAL ? id : '',
  };
};
